import { configureStore } from "@reduxjs/toolkit";
import userReducer from  "./auth-store";
import gameReducer from "./flipCardGameStore/gameSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    game: gameReducer,
  },
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;